<script setup lang="ts">
import Toast from 'primevue/toast';
import VStyledHtml from '@shared/component/VStyledHtml/VStyledHtml.vue';
</script>

<template>
  <Toast position="top-center">
    <template #message="slotProps">
      <VStyledHtml v-sanitized-html="slotProps.message.detail" />
    </template>
  </Toast>
</template>
